import * as types from './types';
import { isServiceError } from '../../utils/errorCodes';
import { getCurrencyDefaultByOpType } from '../../components/Steps/Price/priceConfig';

const initialState = {
  priceInfo: [],
  expenses: null,
  priceError: false,
  priceCompleted: false,
  priceLoading: false,
  priceFeatures: null,
  realEstateType: null
};

function changeCurrencyToDefault(data) {
  return data.map(item => {
    const defaultCurrencyBySiteAndOpType = getCurrencyDefaultByOpType(item.operation_type);
    if (!defaultCurrencyBySiteAndOpType?.code) {
      return item;
    }
    return {
      ...item,
      prices: item.prices.map(price => ({
        ...price,
        currency: defaultCurrencyBySiteAndOpType.code
      }))
    };
  });
}

const DRAFT_STATE = 'DRAFT';

function isPostingDraft(states) {
  return states.some(state => state === DRAFT_STATE);
}

const STEP_PRICE_ID = 7;

function priceStepReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PRICE:
      return { ...state, priceError: false, priceLoading: true };
    case types.GET_PRICE_FAILED:
      return {
        ...state,
        priceError: isServiceError(action?.payload?.status),
        priceLoading: false,
        priceCompleted: true
      };
    case types.GET_PRICE_COMPLETED:
      return {
        ...state,
        priceInfo:
          Number(action?.payload?.step) < STEP_PRICE_ID && isPostingDraft(action?.payload?.posting_statuses)
            ? changeCurrencyToDefault(action?.payload?.price_operation_type)
            : action?.payload?.price_operation_type || action.payload.initialState,
        priceLoading: false,
        priceCompleted: true,
        priceError: false,
        priceFeatures: action?.payload?.price_features || [],
        realEstateType: action?.payload?.real_estate_type_id
      };
    case types.SET_PRICE_INFO:
      return {
        ...state,
        priceInfo: action.payload
      };
    case types.SET_EXPENSES:
      return {
        ...state,
        expenses: action.payload
      };
    case types.RESET_INFO:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

export { priceStepReducer };
